import React from 'react';
import Socials from '../../UI/Socials';
import Contacts from '../../UI/Contacts';
import SelectCity from '../../UI/SelectCity';

const Header = () => {
    return (
        <header className='header'>
            <div className="header__top">
                <div className="container">
                    <div className="row justify-content-end align-items-center">
                        <div className="col-auto me-4 d-none d-lg-block">
                            <Socials />
                        </div>
                        <div className="col-sm col-xl-auto header__border py-2 pe-lg-4">
                            <SelectCity />
                        </div>
                        <div className="col-sm col-xl-auto mb-2 mb-sm-0  ps-lg-4">
                            <div className="header__account">
                                <i className="bi bi-person-circle me-2"></i>
                                <p>Личный кабинет</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container text-center text-sm-start">
                <div className="row header__bottom">
                    <div className="col-sm-auto d-sm-flex">
                        <a className="d-block" href="https://asklepiy-dv.ru/"><img src="img/logo.png" alt="Асклепий" /></a>
                        <div className="header__text ms-4 d-none d-md-flex">
                            <p>Мы выбираем <br /> <span>здоровую жизнь</span></p>
                        </div>
                    </div>
                    <div className="col text-center text-sm-start d-none d-xl-block">
                        <img src="img/header/intro.png" alt="Интро" />
                    </div>
                    <div className="col-sm-auto d-sm-flex justify-content-end mt-4 mt-sm-0">
                        <Contacts lang={true} />
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;